import { useDonate } from "./DonateModal";

export const HEART = "M12 21s-7.5-4.6-10-9.2C.5 8.6 2.4 4.5 6.3 4.5c2.2 0 3.6 1.2 4.4 2.5h.6c.8-1.3 2.2-2.5 4.4-2.5 3.9 0 5.8 4.1 4.3 7.3C19.5 16.4 12 21 12 21z";

export const Donate = () => {
  const openDonate = useDonate();
  return (
  <section className="donate" id="donate" aria-labelledby="donate-title" data-testid="donate-section">
    <div className="wrap donate-in">
      <div>
        <h2 id="donate-title">Help a neighbor find their way forward</h2>
        <p>Your gift helps us host resource events, gather donated essentials, and connect more families, seniors, and caregivers with the support they need.</p>
        <small>Give securely through Zeffy, Square, or PayPal.</small>
      </div>
      <button type="button" className="btn btn-purple" onClick={openDonate} data-testid="donate-band-button">
        <svg viewBox="0 0 24 24" fill="currentColor"><path d={HEART} /></svg>
        Donate now
      </button>
    </div>
  </section>
  );
};
